import { get } from "app/utils/axios/kheti";
import { Disease } from "../models/diagnosis";

const getDiseaseList = async (plantixId: string, cropId: number) => {
  try {
    const response = await get<Disease[]>(
      `plantix/v1/${plantixId}/crop/${cropId}/disease`
    );
    return response;
  } catch (e) {
    return null;
  }
};

export default getDiseaseList;
